export class Average {
  private readonly _avgQueue: Array<number> = [];

  private _avgCount: number;

  private _value?: number;

  public constructor(avgCount: number) {
    this._avgCount = avgCount;
  }

  public update(value: number): number {
    this._avgQueue.push(value);
    if (this._avgQueue.length > this._avgCount) {
      this._avgQueue.shift();
    }
    this._value = this._avgQueue.reduce((sum, val) => sum + val, 0) / this._avgQueue.length;
    return this._value;
  }

  public clear(): void {
    this._avgQueue.splice(0, this._avgQueue.length);
  }

  public resize(avgCount: number): void {
    this._avgCount = avgCount;
    while (this._avgQueue.length > this._avgCount) {
      this._avgQueue.shift();
    }
  }

  public get(): number | undefined {
    return this._value;
  }
}
